import { z } from 'zod'

export const codeVerificationSchemaZ = z.object({
  verificationCode_1: z.string().trim().regex(/^\d$/, 'Musi być pojedynczą cyfrą (0-9)'),
  verificationCode_2: z.string().trim().regex(/^\d$/, 'Musi być pojedynczą cyfrą (0-9)'),
  verificationCode_3: z.string().trim().regex(/^\d$/, 'Musi być pojedynczą cyfrą (0-9)'),
  verificationCode_4: z.string().trim().regex(/^\d$/, 'Musi być pojedynczą cyfrą (0-9)'),
  verificationCode_5: z.string().trim().regex(/^\d$/, 'Musi być pojedynczą cyfrą (0-9)'),
  verificationCode_6: z.string().trim().regex(/^\d$/, 'Musi być pojedynczą cyfrą (0-9)')
})

export type CodeVerificationSchema = z.infer<typeof codeVerificationSchemaZ>
